import React, {createRef, useState, useContext} from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';


const SwitchValue = (props) => {

  const [value, setValue] = useState(props.value || props.set || false);
  if (props.value !== value) {
    setValue(props.value);
  }

  const handleChange = (event) => {
    if (!props.readOnly) {
      setValue(event.target.checked);
      props.onChange(event.target.checked);  
    }
  };

  const disabled = (props.disabled)?{disabled:true}:{};
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  const className = classNames.join(" ");

  return (
    <FormControlLabel
      className={className}
      {...disabled}
      control={
        <Switch
          checked={value}
          onChange={handleChange}
          name={props.name||"switchValue"}
          color={props.color||"primary"}
        />
      }
      label={props.label}
    />
  );

}

export default SwitchValue;